import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxLocaleState} from '../../@interfaces';
import {
	LOCALE_CLEAR_LOCALISATIONS,
	LOCALE_SET_FALLBACK_LOCALE,
	LOCALE_SET_LOCALE,
	LOCALE_SET_LOCALISATIONS
} from './constants';

const reducer: Reducer = (state: IReduxLocaleState = initialState, action: IReduxAction): IReduxLocaleState => {
	switch (action.type) {
		case LOCALE_SET_LOCALE:
			return {...state, locale: action.payload};

		case LOCALE_SET_FALLBACK_LOCALE:
			return {...state, fallbackLocale: action.payload};

		case LOCALE_SET_LOCALISATIONS:
			return {...state, messagesLoaded: true, updatedAt: Date.now()};

		case LOCALE_CLEAR_LOCALISATIONS:
			return {...state, messagesLoaded: false};

		default:
			break;
	}

	return state;
};

export default reducer;
